module.exports = __webpack_public_path__ + "media/images/frontend/today-4aa8410a02f8777cca984fd595ca62bd.png";